<template>
  <div class="wraps">
    <div class="zuku">
      <div class="zuku-bottom">
        <div class="zuku-bottom-left">
          <div class="left_top">
            <el-button v-if="addClassifyBtn" type="primary" size="small" :disabled="!currentId.familyTypeId" @click="getAddTree()"> 新建分类 </el-button>
            <el-button v-if="renameBtn" type="primary" size="small" :disabled="!currentId.familyTypeId || currentId.parentId == '0'" @click="getEditTree()"> 编辑 </el-button>
            <el-button v-if="deleteBtn" class="delete" size="small" type="danger" plain :disabled="!currentId.familyTypeId || currentId.parentId == '0'" @click="deleteTree()">
              删除
            </el-button>
          </div>
          <el-tree
            ref="dicTree"
            class="dicTree"
            :data="libraryTreeList"
            highlight-current
            node-key="familyTypeId"
            :props="defaultProps"
            current-node-key="1"
            :default-expanded-keys="defaultExpandedKeys"
            @current-change="currentDicChange"
          >
            <template #default="{ data }">
              <span :title="data.familyTypeName" class="span-ellipsis">
                <img v-if="data.parentId === '0'" :src="carcass_png" alt="构件" />
                <img v-else :src="classify_png" alt="构件分类" />
                <span style="font-size: 14px">{{ data.familyTypeName }} {{ data.familyFileNum ? "（" + data.familyFileNum + "）" : "" }}</span>
              </span>
            </template>
          </el-tree>
        </div>
        <div class="zuku-bottom-middle">
          <div class="middle_top">
            <el-button v-if="uploadZuBtn" type="primary" size="small" :disabled="!currentId.familyTypeId || currentId.parentId == '0'" @click="getFile('9')"> 上传族 </el-button>
            <el-button v-if="uploadZuBtn" type="primary" size="small" plain :disabled="!currentId.familyTypeId || currentId.parentId == '0'" @click="getFile('10')">
              批量上传族
            </el-button>
            <el-button type="primary" size="small" plain :disabled="batchAddParamsList.length === 0" @click="openBatchAddParamsVisible"> 批量新增参数 </el-button>
            <el-radio-group v-model="flag" size="small" style="float: right; margin-left: 10px">
              <el-radio-button label="0">列表</el-radio-button>
              <el-radio-button label="1">卡片</el-radio-button>
            </el-radio-group>
            <el-input
              v-model="keyWord"
              placeholder="请输入族名进行查询"
              style="float: right; width: 180px"
              size="small"
              :maxlength="20"
              clearable
              @clear="getLibraryTable(1)"
              @keyup.enter.native="getLibraryTable(1)"
            >
            </el-input>
          </div>
          <div v-show="flag == '0'" class="tableList">
            <el-table
              ref="libraryTable"
              class="jk-table"
              height="100%"
              size="small"
              :data="libraryTable"
              style="width: 100%"
              highlight-current-row
              row-key="familyRecordId"
              border
              @row-click="clickRow"
              @selection-change="selectionBatchAddParams"
            >
              <el-table-column type="selection" width="55" align="center" reserve-selection />
              <el-table-column label="序号" type="index" align="center" width="70px" />
              <el-table-column prop="familyRecordName" label="族名称" align="center" width="210px">
                <template #default="{ row }">
                  <div style="display: flex; align-items: center">
                    <rfaFileLightFlag :row="row" @updateLight="uploadBimex" />
                    <el-link type="primary" @click="openView(row, 1)">
                      <span class="tabLinkSpan" :title="row.familyRecordName">{{ row.familyRecordName }}</span>
                    </el-link>
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="createVersion" label="软件版本" align="center" show-overflow-tooltip width="140">
                <template #default="{ row }">
                  {{ row.createVersion ? row.createVersion : "解析中" }}
                </template>
              </el-table-column>
              <el-table-column prop="version" label="版本" align="center" show-overflow-tooltip width="100" />
              <el-table-column prop="createUserName" label="上传人" align="center" show-overflow-tooltip />
              <el-table-column prop="updateTime" label="更新时间" align="center" show-overflow-tooltip />
              <el-table-column label="操作" align="center" width="180">
                <template #default="{ row }">
                  <span v-if="editFamily" class="operation" @click="getFamilyVisible(row)"> 编辑 </span>
                  <span v-if="familyDelete" class="operation" @click="deleteFamily(row)"> 删除 </span>
                  <span class="operation" @click="historyFamily(row)"> 族历史版本 </span>
                  <span class="operation" @click="download(row, 1)"> 下载 </span>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div v-show="flag == '1'" class="cardList">
            <div
              v-for="(item, index) in libraryTable"
              :key="index"
              class="box-card"
              :class="{ imgItemClick: currentFamilyRecordId == item.familyRecordId }"
              @click="clickRow(item)"
            >
              <!-- 有图片时的占位 -->
              <div v-if="item.thumbnailPath != null" style="margin: 13px">
                <el-image style="width: 252px; height: 142px; border-radius: 5px" fit="fill" :src="origin + `${item.thumbnailPath}` + token"></el-image>
              </div>
              <!-- 无图片时的占位 -->
              <div v-else style="margin: 13px">
                <div class="nullpicBox">
                  <img :src="nullpic_png" alt="软件版本" />
                </div>
              </div>
              <div class="item-cell">
                <template>
                  <div style="display: flex; align-items: center">
                    <rfaFileLightFlag :row="item" @updateLight="uploadBimex" />
                    <a type="primary" :title="item.familyRecordName" class="familyRecordNameStyle" @click="openView(item, 1)">{{ item.familyRecordName }}</a>
                  </div>
                </template>
              </div>
              <div class="item-cell">
                <div style="display: flex; width: 80%">
                  <div class="item-left" :title="item.createVersion">
                    <img :src="softwareversion_png" alt="软件版本" />
                    <span> {{ item.createVersion ? item.createVersion : "解析中" }} </span>
                  </div>
                  <div class="item-right" :title="item.version">
                    <img :src="edition_png" alt="版本" />
                    <span>版本 {{ item.version }} </span>
                  </div>
                </div>
                <div class="downstyle" @click="download(item, 1)">下载</div>
              </div>
              <div class="familyHistoryBtn" @click="cardOpenDialog(item)">族历史版本</div>
              <div class="familyHistoryCheckbox">
                <el-checkbox v-model="item.checked" @change="changeChecked(item)"></el-checkbox>
              </div>
            </div>
          </div>
          <div class="page">
            <el-pagination
              v-if="page2.totalCount > 0"
              size="small"
              background
              :current-page="page2.pageNo"
              :page-size="page2.pageSize"
              :page-sizes="[10, 20, 50, 100]"
              :layout="page2.pageLayout"
              :total="page2.totalCount"
              @current-change="familyChangeData"
              @size-change="handleSizeChange2"
            />
          </div>
        </div>
        <div class="zuku-bottom-right">
          <div class="right_top">
            <h2 class="right-center-title">
              <div class="car"></div>
              <span>缩略图</span>
            </h2>
            <div v-if="imgSrc" style="height: 200px; width: 260px; margin: 15px 38px">
              <el-image
                style="width: 100%; height: 100%; border-radius: 5px"
                fit="fill"
                :src="imgSrc ? origin + `${imgSrc}` + token : ''"
                :preview-src-list="imgSrc ? [origin + `${imgSrc}` + token] : ['']"
              >
              </el-image>
            </div>
            <div v-else class="noData">无数据</div>
          </div>
          <div class="right_bottom">
            <h2 class="right-bottom-center-title">
              <div class="car"></div>
              <span>属性</span>
            </h2>
            <div v-if="attributeSelect" class="familyTypeStyle">
              <span style="font-size: 14px; margin-right: 7px">族类型</span>
              <el-select v-model="value" placeholder="请选择" size="small" style="width: 82%" @change="changeTypeProps">
                <el-option v-for="item in attributeSelect.TypeProps" :key="item.FamilyTypeName" :label="item.FamilyTypeName" :value="item.FamilyTypeName"> </el-option>
              </el-select>
            </div>
            <div v-if="attributeDetailsData.length" class="attributeDetails">
              <div v-for="(item, index) in attributeDetailsData" :key="index">
                <span class="tagNameSytle">{{ item.TagName }}</span>
                <ul>
                  <li v-for="(item1, index1) in item.TagContent" :key="index1">
                    <span class="PropNameStyle" :title="item1.PropName">{{ item1.PropName }}</span>
                    <span :title="item1.PropValue">{{ item1.PropValue }}</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 添加/编辑分类弹框 -->
    <el-dialog
      v-dialogDrag
      :title="familyClassificationTitle"
      :visible="familyClassificationVisible"
      width="500px"
      :before-close="familyClassificationVisibleClose"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <div>
        <el-form ref="treeForm" :model="treeForm" label-width="100px" :rules="rules" size="small">
          <el-form-item label="分类名称" prop="name">
            <el-input ref="familyTypeName" v-model.trim="treeForm.name" placeholder="请输入名称" :maxlength="20" />
          </el-form-item>
          <el-form-item label="分类编号" prop="familyTypeNum">
            <el-input v-model.trim="treeForm.familyTypeNum" placeholder="请输入分类编号" :maxlength="20" />
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="familyClassificationVisibleClose">取 消</el-button>
        <el-button type="primary" size="small" @click="familyLibraryTreeSure">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 上传族弹框-编辑 -->
    <el-dialog
      v-if="fileVisible"
      v-dialogDrag
      title="编辑族"
      :visible="fileVisible"
      width="700px"
      :before-close="fileClose"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <div>
        <el-form ref="fileForm" size="small" :model="fileForm" label-width="100px" :rules="fileFormRules">
          <el-form-item label="缩略图">
            <el-upload :action="action" :show-file-list="false" :on-success="handleAvatarSuccess" :headers="upHeader" accept="image/jpeg, image/jpg, image/png">
              <div v-if="!editBase64" class="custom-upload">
                <i class="el-icon-plus"></i>
              </div>
              <img v-else :src="editBase64 ? origin + `${editBase64}` + token : ''" alt="" class="custom-img" />
              <div slot="tip" class="el-upload__tip">建议上传宽260像素，高200像素的图片</div>
            </el-upload>
            <el-button style="margin-top: 10px" size="small" @click="deleteSuo">删除缩略图</el-button>
          </el-form-item>
          <el-form-item label="族名称" prop="familyRecordName" label-width="110px">
            <el-col :span="4">
              <el-input v-model.trim="fileForm.familyTypeNum" readonly class="prefix" :title="fileForm.familyTypeNum" size="small" />
            </el-col>
            <el-col :span="1">
              <span>一</span>
            </el-col>
            <el-col :span="10">
              <el-input v-model.trim="fileForm.familyRecordName" placeholder="请输入族名称" :maxlength="100" size="small" show-word-limit class="familyRecordName" />
            </el-col>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="fileClose">取 消</el-button>
        <el-button size="small" type="primary" @click="submitUpload">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 族历史版本模态框 -->
    <el-dialog
      v-if="oldVisible"
      v-dialogDrag
      title="族历史版本"
      :visible="oldVisible"
      width="1230px"
      height="600px"
      :before-close="oldClose"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <el-table ref="table" class="jk-table" height="500px" size="small" :data="oldData" style="width: 100%" highlight-current-row border>
        <el-table-column prop="name" label="族名称" align="center" show-overflow-tooltip>
          <template #default="{ row }">
            <div style="display: flex; align-items: center">
              <rfaFileLightFlag :row="row" @updateLight="uploadBimexOld" />
              <el-link type="primary" @click="openView(row, 2)">
                {{ row.name }}
              </el-link>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="createVersion" label="软件版本" align="center" show-overflow-tooltip>
          <template #default="{ row }">
            {{ row.createVersion ? row.createVersion : "解析中" }}
          </template>
        </el-table-column>
        <el-table-column prop="version" label="版本" align="center" show-overflow-tooltip />
        <el-table-column prop="userName" align="center" label="上传人" show-overflow-tooltip />
        <el-table-column prop="operDate" align="center" label="状态更新时间" show-overflow-tooltip />
        <el-table-column label="操作" align="center" width="200">
          <template #default="{ row }">
            <el-button type="text" size="small" style="font-size: 18px" @click="download(row, 2)"> 下载 </el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
    <!-- 卡片族历史 -->
    <el-dialog
      v-if="cardVisible"
      v-dialogDrag
      title="族历史版本"
      :visible="cardVisible"
      width="1000px"
      :before-close="cardClose"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <div class="card-history">
        <div v-for="(item, index) in oldData" :key="index" class="box-card">
          <div v-if="item.views != null && item.views.length != 0">
            <el-image style="width: 252px; height: 142px; border-radius: 5px" fit="fill" :src="origin + `${item.thumbnailPath}` + token"></el-image>
          </div>
          <!-- 无图片时的占位 -->
          <div v-else>
            <div style="width: 252px; height: 142px; border-radius: 5px"></div>
          </div>
          <div class="item-cell item-cell-top">
            <span :title="item.name" class="familyNameStyle">{{ item.name }}</span>
          </div>
          <div class="item-cell">
            <span class="item-left" :title="item.createVersion">{{ item.createVersion }}</span>
            <span class="item-right" :title="item.version">{{ item.version }}</span>
          </div>
          <div class="box-card-footer">
            <el-button class="download-btn" type="primary" icon="el-icon-download" size="small" @click="download(item, 2)"></el-button>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" type="primary" @click="cardClose">关闭</el-button>
      </span>
    </el-dialog>
    <!-- 批量上传族弹框 -->
    <el-dialog
      v-if="batchFileVisible"
      v-dialogDrag
      title="批量上传族"
      :visible="batchFileVisible"
      width="700px"
      :before-close="batchFileClose"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      class="batchFileDialog"
    >
      <el-table ref="table" class="jk-table" height="500px" size="small" :data="fileList" style="width: 100%" highlight-current-row border>
        <el-table-column prop="fileName" label="族名称" show-overflow-tooltip align="center" />
        <el-table-column label="操作" align="center">
          <template #default="{ row }">
            <el-button type="text" size="small" style="font-size: 18px" @click="deleteFile(row)"> 删除 </el-button>
          </template>
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer batchFileFooter">
        <div>
          <el-button size="small" type="primary" plain @click="getFile('10')">继续选择</el-button>
        </div>
        <div>
          <el-button size="small" @click="batchFileClose">取 消</el-button>
          <el-button size="small" type="primary" @click="submitFilesUpload">确 定</el-button>
        </div>
      </span>
    </el-dialog>
    <!-- 批量新增新增参数 -->
    <el-dialog
      v-dialogDrag
      :title="batchAddParamsTitle"
      :visible="batchAddParamsVisible"
      width="500px"
      :before-close="batchAddParamsVisibleClose"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <div>
        <el-form ref="batchAddParamsForm" :model="batchAddParamsForm" label-width="100px" :rules="batchAddParamsRules" label-position="top" size="small">
          <el-form-item label="选择类别">
            <el-radio-group v-model="batchAddParamsForm.type">
              <el-radio :label="1">类型(Y)</el-radio>
              <el-radio :label="2">实例(I)</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="名称(N)" prop="name">
            <el-input ref="name" v-model.trim="batchAddParamsForm.name" placeholder="请输入名称(N)" size="small" :maxlength="20" />
          </el-form-item>
          <el-form-item label="参数类型(T)" prop="paramTypeName">
            <el-select v-model="batchAddParamsForm.paramTypeName" placeholder="请选择" size="small" style="width: 100%" @change="changeParamType">
              <el-option v-for="item in parameterTypeList" :key="item.id" :label="item.cnName" :value="item.cnName"> </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="参数分组方式(G)" prop="paramGroupName">
            <el-select v-model="batchAddParamsForm.paramGroupName" placeholder="请选择" size="small" style="width: 100%" @change="changeParamGroup">
              <el-option v-for="item in parameterGroupMethodList" :key="item.id" :label="item.cnName" :value="item.cnName"> </el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="batchAddParamsVisibleClose">取 消</el-button>
        <el-button type="primary" size="small" @click="batchAddParamsSure">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
const addParamsForm = () => ({
  type: 1,
  name: "",
  paramTypeCode: "",
  paramTypeId: "",
  paramTypeName: "",
  paramGroupCode: "",
  paramGroupId: "",
  paramGroupName: "",
  familyRecordIds: []
});
import { getToken, downloadFile, downloadUrltoken, uploadDataUrl } from "@/CommonDP/utils";
import routerInit from "@/CommonDP/router";
import { mapState } from "vuex";
import { checkPermission } from "@/CommonDP/utils/routeAuth";
import XtDesignRequest from "@/CommonDP/service/XtDesign-service";
import familyLibraryRequest from "@/CommonDP/service/familyLibrary-service";
import docService from "@/CommonDP/service/doc-service";
import rfaFileLightFlag from "./components/rfaFileLightFlag";
import createProject from "@/CommonDP/service/createProject-service";
import { uploader } from "@/CommonDP/utils/IUploader/dp";

export default {
  name: "FamilyLibrary",
  components: {
    rfaFileLightFlag
  },
  data() {
    return {
      addClassifyBtn: checkPermission(this.$allPerms.ZUNEWFOLDER),
      renameBtn: checkPermission(this.$allPerms.ZURENAME),
      deleteBtn: checkPermission(this.$allPerms.ZUDELETE),
      uploadZuBtn: checkPermission(this.$allPerms.ZUUPLOAD),
      editFamily: checkPermission(this.$allPerms.ZUEDITFAMILY),
      familyDelete: checkPermission(this.$allPerms.FAMILYDELETE),
      upHeader: { Authorization: "Bearer " + getToken() },
      carcass_png: require("@/CommonDP/assets/application/familyLibrary/carcass.png"),
      classify_png: require("@/CommonDP/assets/application/familyLibrary/classify.png"),
      softwareversion_png: require("@/CommonDP/assets/application/familyLibrary/softwareversion.png"),
      edition_png: require("@/CommonDP/assets/application/familyLibrary/edition.png"),
      nullpic_png: require("@/CommonDP/assets/application/familyLibrary/nullpic.png"),
      imgSrc: "", // 存放族库图片
      defaultExpandedKeys: [], // 默认展开
      libraryTreeList: [], // 族类型树
      libraryTable: [], // 族列表
      currentId: {}, // 目录树选中
      defaultProps: {
        label: "familyTypeName",
        children: "children"
      },
      familyClassificationVisible: false, // 添加弹框
      treeForm: {
        name: "",
        familyTypeNum: ""
      },
      rules: {
        name: [{ required: true, message: "请输入名称", trigger: "blur" }],
        familyTypeNum: [{ required: true, message: "请输入分类编号", trigger: "blur" }]
      },
      fileFormRules: {
        familyRecordName: [{ required: true, message: "请输入族名称", trigger: "blur" }]
      },
      keyWord: "", // 关键词
      familyRecordId: "", // 族id
      attributeSelect: {},
      page2: {
        pageNo: 1,
        pageSize: 20,
        totalCount: 0,
        pageLayout: "total, sizes,prev, pager, next, jumper" // 分页组件
      },
      fileVisible: false, // 上传族弹框
      fileForm: {
        familyPicData: "",
        familyTypeNum: "",
        familyRecordId: "",
        familyRecordName: ""
      },
      fileData: "", // formdata对象
      fileList: [], // 文件列表
      authorityPageSelect: [], // 勾选的人员数据
      oldVisible: false, // 历史版本弹框
      oldData: [], // 族历史版本记录
      authorityRadio: "", // 权限单选框
      flag: "0", // 控制列表和卡片得展示,0列表,1卡片
      replaceVisible: false, // 替换族弹框
      newVersionRow: {}, // 上传新版本文件用的数据（行数据）
      cardVisible: false, // 卡片族历史版本数据
      batchFileVisible: false, // 批量上传弹框
      // 缩略图base64
      editBase64: "",
      timer: null, // 定时器
      familyClassificationTitle: "新建分类",
      typeKey: "9",
      value: "",
      attributeDetailsData: [],
      trendsPrjId: "",
      origin: "",
      token: "",
      action: "",
      currentFamilyRecordId: "",
      tableRow: {},
      timerOld: null, // 定时器
      batchAddParamsVisible: false,
      batchAddParamsTitle: "批量新增参数",
      batchAddParamsRules: {
        name: [{ required: true, message: "请输入名称(N)", trigger: "blur" }],
        paramTypeName: [{ required: true, message: "请选择参数类型(T)", trigger: "change" }],
        paramGroupName: [{ required: true, message: "请选择参数分组方式(G)", trigger: "change" }]
      },
      batchAddParamsForm: addParamsForm(),
      batchAddParamsList: [],
      parameterTypeList: [],
      parameterGroupMethodList: [],
      supplementProperties: []
    };
  },
  computed: {
    ...mapState({
      enterpriseId: (state) => state.enterprise.enterpriseId,
      prjId: (state) => state.projectMg.prjObj.prjId,
      userInfo: (state) => state.user.userInfo
    })
  },
  watch: {
    flag(val) {
      if (val === "0") {
        this.$nextTick(() => {
          this.$refs.libraryTable?.setCurrentRow(this.tableRow);
        });
      }
    }
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
    // 页面关闭时清除定时器
    clearInterval(this.timer);
    this.timer = null;
  },
  methods: {
    async init() {
      this.origin = window.location.origin + this.$env.VUE_APP_API;
      this.token = getToken();
      this.action = uploadDataUrl();
      await this.getLibraryTree(1);
      await this.$nextTick();
      if (this.libraryTreeList.length) {
        this.getLibraryTable();
      }
      this.familyDocByEnterpriseId();
    },

    async familyDocByEnterpriseId() {
      const res = await familyLibraryRequest.getFamilyDocByEnterpriseId(this.enterpriseId);
      this.trendsPrjId = res.data;
    },
    async deleteFamily(val) {
      await this.$confirm("此操作将删除此族，是否继续？");
      await familyLibraryRequest.deleteFamilyRecords([val.familyRecordId]);
      await this.getLibraryTree();
      await this.$nextTick();
      if (this.libraryTreeList.length) {
        this.page2.pageNo = 1;
        this.getLibraryTable();
      }
      this.$message({
        showClose: true,
        type: "success",
        message: "删除成功"
      });
    },
    changeTypeProps(val) {
      if (this.attributeSelect) {
        const TypePropsChild = this.attributeSelect.TypeProps.filter(({ FamilyTypeName }) => FamilyTypeName === val)[0];
        const arr1 = TypePropsChild.GroupData;
        const arr2 = this.supplementProperties;
        const diff = (arrayA, arrayB) => arrayB.filter((item) => !arrayA.some((other) => other.TagName === item.TagName));
        const newArr = [...diff(arr1, arr2), ...diff(arr2, arr1)];
        this.attributeDetailsData = newArr;
        for (let i = 0; i < TypePropsChild.GroupData.length; i++) {
          const obj = this.supplementProperties.filter(({ TagName }) => TagName === TypePropsChild.GroupData[i].TagName)[0];
          if (obj) {
            TypePropsChild.GroupData[i].TagContent = TypePropsChild.GroupData[i].TagContent.concat(obj.TagContent);
            this.attributeDetailsData.push(TypePropsChild.GroupData[i]);
          }
        }
      }
    },
    unique(arr) {
      const res = new Map();
      return arr.filter((a) => !res.has(a.TagName) && res.set(a.TagName, 1));
    },
    // 上传族/批量上传族 opan
    async getFile(val) {
      this.typeKey = val;
      const params = {
        prjId: this.trendsPrjId,
        folderId: this.currentId.familyTypeId,
        versionId: ""
      };
      const list = await uploader.open({ params, accept: '.rfa', multiple: val === "10", once: true, showPanel: true });
      list.forEach(this.fileAdded);
    },
    // 上传组件返回的数据
    fileAdded(val) {
      if (val.fileId) {
        this.fileList.push(val);
      }
      if (this.typeKey === "9") {
        this.submitFilesUpload();
      } else {
        this.batchFileVisible = true;
      }
    },
    // 重新轻量化
    uploadBimex(row) {
      if (!this.timer) {
        this.timer = setInterval(() => {
          this.getLibraryTable();
        }, 14000);
      }
      if (this.isSuccess(row)) {
        this.$confirm("当前文件已轻量化成功,是否重新轻量化?", "提示").then(() => {
          this.updateLight(row, 0);
          this.getLibraryTable();
        });
      } else {
        this.updateLight(row, 0);
        this.getLibraryTable();
      }
    },
    uploadBimexOld(row) {
      if (!this.timerOld) {
        this.timerOld = setInterval(() => {
          this.getOldData(this.newVersionRow);
        }, 14000);
      }
      if (this.isSuccess(row)) {
        this.$confirm("当前文件已轻量化成功,是否重新轻量化?", "提示").then(() => {
          this.updateLight(row, 0);
        });
      } else {
        this.updateLight(row, 0);
      }
    },
    updateLight(row, type) {
      const prjId = this.trendsPrjId;
      row.status = "1";
      const status = row.status;
      let messageType;
      type === 1 ? (messageType = "优先轻量化操作") : (messageType = "重新轻量化操作");
      const fileIds = row.fileId || row.familyRecordId;
      docService
        .updateLight(prjId, fileIds, row.version)
        .then((res) => {
          if (res.result === "0") {
            row.status = "1";
            this.$message.success(`${messageType}成功`);
          } else {
            row.status = status;
            this.$message.warning(`${messageType}失败`);
          }
        })
        .catch(() => {
          row.status = status;
        });
    },
    // 预览1
    openView(row, tyep) {
      if (this.isWaiting(row)) {
        this.$message.warning("文件还未轻量化，无法预览");
        return;
      } else if (this.isFail(row)) {
        this.$message.warning("文件轻量化失败，无法预览");
        return;
      } else if (this.isDealing(row)) {
        this.$message.warning("文件轻量化中，无法预览");
        return;
      } else if (this.isSuccess(row)) {
        const { version } = row;
        const fileIds = tyep === 2 ? row.fileId : row.familyRecordId;
        const modelParams = { fileIds: fileIds, versionIds: version, noNeedIssue: true };
        this.windowOpen({ path: "/modelpro", query: modelParams });
      }
    },
    isWaiting(row) {
      return row.status === "1" || row.status === "5" || row.status === "99";
    },
    isSuccess(row) {
      return row.status === "2" || row.status === "6";
    },
    isFail(row) {
      return row.status === "3" || row.status === "7";
    },
    isDealing(row) {
      return row.status === "4" || row.status === "8";
    },
    // 预览2
    windowOpen(routeInfo) {
      const router = routerInit();
      const routeUrl = router.resolve(routeInfo);
      window.open(routeUrl.href, "_blank");
    },
    // 打开卡片族历史弹框
    cardOpenDialog(item) {
      this.newVersionRow = item;
      this.getOldData(item);
      this.oldVisible = true;
    },
    // 关闭卡片族历史弹框
    cardClose() {
      this.cardVisible = false;
    },

    // 关闭替换族弹框
    replaceClose() {
      this.replaceVisible = false;
    },
    // 打开族历史弹框
    historyFamily(row) {
      this.newVersionRow = row; // 上传新版本按钮用的行数据
      this.getOldData(row);
      this.oldVisible = true;
    },
    // 分页
    handleSizeChange2(val) {
      this.page2.pageNo = 1;
      this.page2.pageSize = val;
      this.getLibraryTable();
    },
    // 上传族弹框-编辑
    submitUpload() {
      this.$refs.fileForm.validate(async (valid) => {
        if (!valid) return;
        const params = {
          familyPicData: this.fileForm.familyPicData ? this.fileForm.familyPicData : "",
          familyRecordId: this.fileForm.familyRecordId,
          familyRecordName: this.fileForm.familyRecordName + ".rfa",
          familyTypeId: this.currentId.familyTypeId,
          familyTypeName: this.currentId.familyTypeName
        };
        await familyLibraryRequest.updateFamilyRecord(params);
        this.fileVisible = false;
        this.page2.pageNo = 1;
        this.getLibraryTable();
        this.$message({
          message: "修改成功",
          type: "success"
        });
      });
    },
    // 下载
    download(row, val) {
      const fileId = val === 1 ? row.familyRecordId : row.fileId;
      const prjId = this.trendsPrjId;
      const downzipurl = val === 1 ? downloadUrltoken(prjId, fileId) : downloadUrltoken(prjId, fileId, row.version);
      downloadFile(downzipurl);
    },
    // 族类型树
    getLibraryTree(val) {
      return familyLibraryRequest.getFamilyLibrary(this.enterpriseId).then(({ data }) => {
        this.libraryTreeList = data;
        if (val && data.length) {
          this.currentId = data[0];
        }
        this.defaultExpandedKeys = [this.currentId.familyTypeId];
        this.$nextTick(() => {
          if (this.$refs.dicTree) this.$refs.dicTree.setCurrentKey(this.currentId.familyTypeId);
        });
        this.libraryTable = [];
      });
    },
    // 打开新增族类型弹框
    async getAddTree() {
      this.treeForm.name = "";
      this.treeForm.familyTypeNum = "";
      this.familyClassificationTitle = "新建分类";
      this.familyClassificationVisible = true;
      await this.$nextTick();
      this.$refs.familyTypeName.focus();
      this.$refs.treeForm.clearValidate();
    },
    // 打开重命名弹框
    async getEditTree() {
      this.treeForm.name = this.currentId.familyTypeName;
      this.treeForm.familyTypeNum = this.currentId.familyTypeNum;
      this.familyClassificationTitle = "编辑分类";
      this.familyClassificationVisible = true;
      await this.$nextTick();
      this.$refs.treeForm.clearValidate();
    },
    // 打开修改族弹框
    getFamilyVisible(row) {
      this.fileForm.familyRecordId = row.familyRecordId;
      this.fileForm.familyRecordName = row.familyRecordName.slice(0, -4);
      this.fileForm.familyTypeNum = row.familyTypeNum ? row.familyTypeNum : "";
      this.editBase64 = row.thumbnailPath ? row.thumbnailPath : "";
      this.fileVisible = true;
    },
    // 关闭添加弹框
    familyClassificationVisibleClose() {
      this.familyClassificationVisible = false;
    },
    // 编辑族弹框关闭
    fileClose() {
      this.fileVisible = false;
      this.editBase64 = "";
    },
    // 历史版本族弹框关闭
    oldClose() {
      clearInterval(this.timerOld);
      this.timerOld = null;
      this.oldVisible = false;
    },
    // 添加族类型
    familyLibraryTreeSure() {
      this.$refs.treeForm.validate(async (valid) => {
        if (!valid) return;
        if (this.familyClassificationTitle === "新建分类") {
          this.addFamilyLibraryTree();
        } else {
          this.editFamilyLibraryTree();
        }
      });
    },
    // 添加族分类
    async addFamilyLibraryTree() {
      const { name, familyTypeNum } = this.treeForm;
      const params = {
        enterpriseId: this.enterpriseId,
        parentId: this.currentId.familyTypeId,
        familyTypeName: name,
        familyTypeNum,
        remark: "",
        sortOrder: 1
      };
      await familyLibraryRequest.addFamilyLibrary(params);
      await this.getLibraryTree();
      await this.$nextTick();
      if (this.libraryTreeList.length) {
        this.page2.pageNo = 1;
        this.getLibraryTable();
      }
      this.familyClassificationVisible = false;
      this.$message({
        type: "success",
        message: "添加成功"
      });
    },
    // 修改族分类
    async editFamilyLibraryTree() {
      const params = {
        familyTypeId: this.currentId.familyTypeId,
        familyTypeName: this.treeForm.name,
        familyTypeNum: this.treeForm.familyTypeNum
      };
      await familyLibraryRequest.editFamilyLibrary(params);
      this.familyClassificationVisible = false;
      await this.getLibraryTree(1);
      await this.$nextTick();
      if (this.libraryTreeList.length) {
        this.page2.pageNo = 1;
        this.getLibraryTable();
      }
      this.$message({
        type: "success",
        message: "修改成功"
      });
    },
    // 删除族类型
    async deleteTree() {
      await this.$confirm("此操作将删除此族类型，是否继续？");
      await familyLibraryRequest.deleteFamilyType(this.currentId.familyTypeId);
      this.currentId = {};
      await this.getLibraryTree(1);
      await this.$nextTick();
      if (this.libraryTreeList.length) {
        this.page2.pageNo = 1;
        this.getLibraryTable();
      }
      this.$message({
        showClose: true,
        type: "success",
        message: "删除成功"
      });
    },
    // 表格数据
    getLibraryTable(val) {
      const { pageSize, pageNo } = this.page2;
      const param = {
        enterpriseId: this.enterpriseId,
        pageNum: val || pageNo,
        pageSize,
        familyTypeId: this.currentId.familyTypeId ? this.currentId.familyTypeId : 1,
        familyRecordName: this.keyWord
      };
      familyLibraryRequest.getLibraryList(param).then(({ data, totalCount, pageIndex }) => {
        this.page2.pageNo = pageIndex;
        this.page2.totalCount = totalCount;
        data.forEach((item) => {
          this.$set(item, "checked", false);
        });
        const commitErrorList = [...data].filter((x) => [...this.batchAddParamsList].some((y) => y.familyRecordId === x.familyRecordId));
        console.log(commitErrorList, "commitErrorList");
        commitErrorList.forEach((item) => {
          this.$set(item, "checked", true);
        });
        this.libraryTable = data;
        this.currentFamilyRecordId = "";
        this.value = "";
        this.attributeSelect = {};
        this.imgSrc = "";
        this.attributeDetailsData = [];
        this.tableRow = {};
        if (data[0]) {
          this.clickRow(data[0]);
        }
      });
    },
    // 族表格分页点击
    familyChangeData(val) {
      this.page2.pageNo = val;
      this.getLibraryTable();
    },
    // 获取历史版本数据
    async getOldData(val) {
      const res = await XtDesignRequest.queryBaseProperty(val.familyRecordId, 0, "");
      this.oldData = res.data;
    },
    // 点击族列表的某一行
    clickRow(row) {
      // 获取属性
      this.tableRow = row;
      this.currentFamilyRecordId = row.familyRecordId;
      this.attributeSelect = JSON.parse(row.properties);
      const arr = row.supplementProperties;
      arr.forEach((element) => {
        this.$set(element, "PropName", element.name);
        this.$set(element, "PropValue", "");
      });
      this.supplementProperties = Object.entries(
        arr.reduce(
          (prev, next) => ({
            ...prev,
            [next.paramGroupName]: [...(prev[next.paramGroupName] || []), { ...next }]
          }),
          {}
        )
      ).map(([TagName, TagContent]) => ({ TagName, TagContent }));

      this.value = this.attributeSelect && this.attributeSelect.TypeProps.length > 0 ? this.attributeSelect.TypeProps[0].FamilyTypeName : "";
      this.attributeDetailsData = [];
      if (this.value) {
        this.changeTypeProps(this.value);
      }
      // 获取图片
      this.imgSrc = row.thumbnailPath ? row.thumbnailPath : "";
      if (this.flag === "0") {
        this.$nextTick(() => {
          this.$refs.libraryTable?.setCurrentRow(row);
        });
      }
    },
    // 选中目录树
    currentDicChange(val) {
      this.currentId = val;
      this.libraryTable = [];
      this.page2.pageNo = 1;
      this.$refs.libraryTable.clearSelection();
      this.getLibraryTable();
    },

    // 删除批量上传文件
    deleteFile(row) {
      this.$confirm("此操作将永久删除该文件, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        this.fileList = this.fileList.filter((item) => item.fileId !== row.fileId);
        this.$message({
          type: "success",
          message: "删除成功!"
        });
      });
    },
    // 关闭批量上传弹框
    batchFileClose() {
      this.fileList = [];
      this.batchFileVisible = false;
    },

    // 批量上传族
    async submitFilesUpload() {
      const fileList = this.fileList.map((item) => {
        return {
          familyPicData: "",
          familyRecordId: item.fileId,
          familyRecordName: item.fileName,
          familyTypeId: this.currentId.familyTypeId,
          familyTypeName: this.currentId.familyTypeName
        };
      });
      this.fileList = [];
      const params = {
        familyList: fileList
      };
      await familyLibraryRequest.getFamilyNewUploadFamilys(params);
      this.batchFileVisible = false;
      await this.getLibraryTree();
      await this.$nextTick();
      if (this.libraryTreeList.length) {
        this.getLibraryTable();
      }
    },

    handleAvatarSuccess(response, file) {
      if (response.result === "0" && response.data) {
        this.fileForm.familyPicData = response.data.fileKey;
        this.editBase64 = "/download/" + response.data.filePath + "?token=";
      }
    },
    deleteSuo() {
      this.fileForm.familyPicData = "";
      this.editBase64 = "";
    },
    selectionBatchAddParams(val) {
      this.batchAddParamsList.forEach((element) => {
        if (element) {
          this.$set(element, "checked", false);
        }
      });
      val.forEach((element) => {
        if (element) {
          this.$set(element, "checked", true);
        }
      });
      this.batchAddParamsList = val;
    },
    async getDicList() {
      const res = await createProject.dicList("ParamType");
      this.parameterTypeList = res.data;
      const res2 = await createProject.dicList("ParamGroup");
      this.parameterGroupMethodList = res2.data;
    },
    async openBatchAddParamsVisible() {
      this.getDicList();
      this.batchAddParamsForm = addParamsForm();
      this.batchAddParamsVisible = true;
      await this.$nextTick();
      this.batchAddParamsForm.type = 1;
      this.$refs.batchAddParamsForm.clearValidate();
    },
    // 关闭添加弹框
    batchAddParamsVisibleClose() {
      this.batchAddParamsVisible = false;
    },
    batchAddParamsSure() {
      this.$refs.batchAddParamsForm.validate(async (valid) => {
        if (!valid) return;
        const familyRecordIds = this.batchAddParamsList.map((item) => item.familyRecordId);
        this.batchAddParamsForm.familyRecordIds = familyRecordIds;
        await familyLibraryRequest.bathSupplementProperties(this.batchAddParamsForm);
        this.batchAddParamsVisible = false;
        this.$message({ type: "success", message: "批量增加参数成功" });
        this.getLibraryTable();
      });
    },
    changeParamType(val) {
      if (val) {
        this.batchAddParamsForm.paramTypeId = 1;
        this.batchAddParamsForm.paramTypeCode = this.parameterTypeList.filter(({ cnName }) => cnName === val)[0].enName;
      } else {
        this.batchAddParamsForm.paramTypeId = "";
        this.batchAddParamsForm.paramTypeCode = "";
      }
    },
    changeParamGroup(val) {
      if (val) {
        this.batchAddParamsForm.paramGroupId = this.parameterGroupMethodList.filter(({ cnName }) => cnName === val)[0].id;
        this.batchAddParamsForm.paramGroupCode = this.parameterGroupMethodList.filter(({ cnName }) => cnName === val)[0].enName;
      } else {
        this.batchAddParamsForm.paramGroupId = "";
        this.batchAddParamsForm.paramGroupCode = "";
      }
    },
    changeChecked(val) {
      if (val.checked) {
        this.batchAddParamsList.push(val);
        this.$refs.libraryTable.toggleRowSelection(val);
      } else {
        const index = this.batchAddParamsList.findIndex((item) => item.familyRecordId === val.familyRecordId);
        this.batchAddParamsList.splice(index, 1);
        this.$refs.libraryTable.toggleRowSelection(val, false);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.wraps {
  width: 100%;
  height: 100%;
  padding: var(--middle-space);

  .zuku {
    width: 100%;
    height: 100%;
    background-color: #fff;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    background-color: #eff1f6;

    .zuku-bottom {
      flex: 1;
      display: flex;
      overflow: hidden;
    }
  }

  .zuku-bottom-left {
    overflow: hidden;
    display: flex;
    flex-direction: column;
    width: 264px;
    border-right: 1px solid #f2f2f2;
    background-color: #fff;

    .left_top {
      display: flex;
      padding: var(--middle-space) var(--big-space);
      border-bottom: 1px solid #e5e8f1;
    }

    .dicTree {
      overflow: auto;
      flex: 1;
      font-size: 14px;
      padding-top: var(--middle-space);

      img {
        margin-right: 6px;
      }

      .span-ellipsis {
        width: 100%;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        display: flex;
        align-items: stretch;
      }
    }
  }

  .zuku-bottom-middle {
    overflow: hidden;
    flex: 1;
    border-right: 1px solid #f2f2f2;
    display: flex;
    flex-direction: column;
    margin-left: var(--middle-space);
    background-color: #fff;

    .middle_top {
      padding: var(--middle-space) var(--big-space);
      border-bottom: 1px solid #e5e8f1;
    }

    .tableList {
      flex: 1;
      overflow: hidden;
      padding: var(--middle-space) var(--big-space) 0;
      .operation {
        color: #4777e7;
        cursor: pointer;
        padding: 0 3px;
      }
    }

    .cardList {
      flex: 1;
      overflow: hidden;
      padding: var(--middle-space) var(--big-space) 0;
      display: flex;
      flex-wrap: wrap;
      flex-direction: row;
      overflow: auto;

      .box-card {
        position: relative;
        width: 278px;
        height: 235px;
        margin: 10px 0 90px 10px;
        border: 1px solid #e5e8f1;
        border-radius: 4px;
        background-color: #fff;
        cursor: pointer;

        .box-card-footer {
          display: flex;
          justify-self: center;
          position: absolute;
          left: 50%;
          bottom: 10px;
          transform: translateX(-50%);
        }

        .item-cell-top {
          border-top: 1px solid var(--info-color) !important;
        }

        .item-cell {
          display: flex;
          justify-content: space-between;
          color: #333;
          padding: 0 13px;

          .familyRecordNameStyle {
            width: 100%;
            font-size: 14px;
            line-height: 30px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            text-align: center;
          }
        }

        .item-left,
        .item-right {
          display: flex;
          align-items: center;
          width: 50%;

          span {
            height: 30px;
            line-height: 30px;
            font-size: 14px;
            text-indent: 5px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            text-align: center;
          }
        }

        .downstyle {
          width: 45px;
          height: 23px;
          line-height: 23px;
          background: #f2f3f8;
          border-radius: 15px;
          text-align: center;
          color: #4777e7;
        }

        .familyHistoryBtn {
          position: absolute;
          top: 20px;
          right: 20px;
          font-size: 14px;
          width: 86px;
          height: 22px;
          line-height: 22px;
          background: #dee5ef;
          border-radius: 15px;
          text-align: center;
        }

        .nullpicBox {
          width: 252px;
          height: 142px;
          border-radius: 5px;
          background: #edf0f5;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .familyHistoryCheckbox {
          position: absolute;
          top: 5px;
          left: 10px;
          font-size: 14px;
          border-radius: 15px;
          text-align: center;
        }
      }

      .box-card:hover {
        box-shadow: 0px 0px 8px rgba(13, 107, 193, 0.35);
      }

      .imgItemClick {
        box-shadow: 0px 0px 8px rgba(13, 107, 193, 0.35);
      }
    }

    .page {
      width: 100%;
      margin: var(--middle-space) auto;

      .el-pagination {
        float: right;
      }
    }
  }

  .zuku-bottom-right {
    display: flex;
    flex-direction: column;
    overflow: hidden;
    width: 334px;
    background-color: #fff;

    .right_top {
      width: 334px;

      .right-center-title {
        background: #fff;
        padding: var(--middle-space) var(--big-space);
        border-bottom: 1px solid #e5e8f1;
        color: #000000;
        display: flex;
        align-items: center;
        span {
          font-size: 14px;
          line-height: 32px;
        }
      }

      .noData {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 200px;
      }
    }

    .right_bottom {
      height: 1px;
      flex: 1 0 1px;
      display: flex;
      flex-direction: column;

      .right-bottom-center-title {
        background: #f4f5f9;
        padding: var(--middle-space) var(--big-space);
        color: #000000;
        display: flex;
        align-items: center;
        span {
          font-size: 14px;
        }
      }
    }

    .familyTypeStyle {
      display: flex;
      padding: 0 var(--big-space);
      align-items: center;
      margin: var(--middle-space) 0px;
    }

    .attributeDetails {
      height: 1px;
      flex: 1 0 1px;
      padding: 0 var(--big-space) var(--middle-space);
      overflow: auto;

      .tagNameSytle {
        font-size: 14px;
        padding: 15px 0px;
        display: block;
        width: 100%;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }

      ul {
        border: 1px solid #e5e8f1;

        li {
          display: flex;
          justify-content: center;
          align-items: center;
          border-bottom: 1px solid #e5e8f1;

          span {
            height: 30px;
            line-height: 30px;
            width: 50%;
            text-align: center;
            font-size: 12px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
          }

          .PropNameStyle {
            border-right: 1px solid #e5e8f1;
            background: #f4f7fc;
          }
        }

        li:last-child {
          border-bottom: 0px;
        }
      }
    }

    .attributeDetails > div:first-child span {
      padding-top: 0px;
    }

    .radio-group {
      width: 100%;
      padding: 10px;

      .radio-item {
        width: 50%;

        /deep/ .el-radio-button__inner {
          width: 100%;
        }
      }
    }

    .title {
      height: 30px;
      line-height: 30px;
      background-color: #dde1d4;
    }

    /deep/.el-tabs__item {
      color: #fff;
    }

    /deep/.el-tabs__item.is-active {
      color: #e50323;
    }

    /deep/.el-tabs__active-bar {
      background-color: #e50323;
    }

    .car {
      background: var(--theme-color);
      width: 3px;
      height: 12px;
      margin-right: var(--small-space);
    }
  }

  .page {
    display: flex;
    justify-content: flex-end;
  }

  .span-ellipsis {
    width: 100%;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  .card-history {
    height: 550px;
    padding: 0 10px;
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    overflow: auto;

    .box-card {
      position: relative;
      width: 252px;
      height: 142px;
      margin: 11px 0 0 10px;
      border: 1px solid #eee;
      background-color: #eee;

      .box-card-footer {
        display: flex;
        justify-self: center;
        position: absolute;
        left: 50%;
        bottom: 10px;
        transform: translateX(-50%);
      }

      .item-cell-top {
        border-top: 1px solid var(--info-color) !important;
      }

      .item-cell {
        display: flex;
        flex: 1;
        color: #333;

        .familyNameStyle {
          padding-left: 10px;
          padding-right: 10px;
          width: 100%;
          font-size: 14px;
          line-height: 30px;
          border-left: 1px solid var(--info-color);
          border-right: 1px solid var(--info-color);
          border-bottom: 1px solid var(--info-color);
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          text-align: center;
        }
      }

      .item-left,
      .item-right {
        width: 50%;
        height: 25px;
        line-height: 25px;
        font-size: 14px;
        border-right: 1px solid var(--info-color);
        border-bottom: 1px solid var(--info-color);
        text-indent: 5px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        text-align: center;
      }

      .item-left {
        border-left: 1px solid var(--info-color);
      }
    }
  }

  /deep/ .prefix .el-input__inner {
    border: none;
    width: 90px;
    padding: 0px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .custom-upload {
    width: 140px;
    height: 140px;
    border-radius: 6px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px dotted #ccc;

    i {
      font-size: 35px;
      color: var(--info-color);
    }
  }

  .custom-img {
    width: 140px;
    height: 140px;
    border-radius: 6px;
    border: 1px dotted #ccc;
  }

  .batchFileDialog {
    /deep/ .el-dialog {
      .el-dialog__footer {
        text-align: start;

        .batchFileFooter {
          display: flex;
          justify-content: space-between;
        }
      }
    }
  }

  .familyRecordName {
    /deep/ .el-input__inner {
      padding-right: 60px;
    }
  }
}
</style>
